




















import { Vue, Component } from "vue-property-decorator";
@Component
export default class UFlexibleHeader extends Vue {
  public get growRight() {
    return ["cta", "select"].every(key =>
      Object.keys(this.$slots).includes(key)
    );
  }
  public get growLeft() {
    return !this.growRight;
  }
}
